<template>
  <v-container grid-list-xl>
    <v-layout
      row
      wrap
    >
      <v-flex
        lg12
        sm12
        xs12
      >
        <v-form
          class="app-form"
          @submit.prevent="onSubmit"
        >
          <v-expansion-panels class="app-expansion-panels">
            <v-expansion-panel>
              <v-expansion-panel-header class="app-expansion-panel-header mb-0">
                <h4 class="text">
                  <v-icon>filter_alt</v-icon>
                  <span>Filtrar</span>
                </h4>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="app-expansion-panel-content">
                <v-row class="mt-3">
                  <v-col
                    :lg="4"
                    :md="6"
                    :sm="6"
                    :xs="12"
                  >
                    <MonthFilterPicker
                      :key="monthPickerKey"
                      @mesAno="onChangeMesCompetencia"
                    />
                  </v-col>
                  <v-col
                    :lg="4"
                    :md="6"
                    :sm="6"
                    :xs="12"
                  >
                    <v-text-field
                      v-model="filters.dataVencimentoDe"
                      label="Data de vencimento inicial"
                      type="date"
                      outlined
                      dense
                    />
                  </v-col>
                  <v-col
                    :lg="4"
                    :md="6"
                    :sm="6"
                    :xs="12"
                  >
                    <v-text-field
                      v-model="filters.dataVencimentoAte"
                      label="Data de vencimento final"
                      type="date"
                      outlined
                      dense
                    />
                  </v-col>
                  <v-col
                    :lg="4"
                    :md="6"
                    :sm="6"
                    :xs="12"
                  >
                    <v-text-field
                      v-model="filters.nup"
                      :clearable="true"
                      label="NUP"
                      outlined
                      dense
                    />
                  </v-col>
                  <v-col
                    :lg="4"
                    :md="6"
                    :sm="6"
                    :xs="12"
                  >
                    <v-text-field
                      v-model="filters.autoInfracao"
                      :clearable="true"
                      label="Auto de infração"
                      outlined
                      dense
                    />
                  </v-col>
                </v-row>
                <div class="mt-3 d-flex">
                  <v-spacer />
                  <v-btn
                    outlined
                    color="error"
                    type="button"
                    class="mr-2"
                    @click.prevent.stop="clearFilters"
                  >
                    <v-icon size="14">
                      delete
                    </v-icon>Limpar Filtros
                  </v-btn>
                  <v-btn
                    depressed
                    color="primary"
                    type="submit"
                  >
                    Filtrar
                  </v-btn>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-form>
      </v-flex>

      <v-flex
        lg12
        sm12
        xs12
        class="pt-0"
      >
        <v-data-table
          :headers="headers"
          :items="items"
          :item-key="'_rowKey'"
          :loading="isLoading"
          :items-per-page="pagination.itemsPerPage"
          :options.sync="pagination"
          :server-items-length="total"
          :footer-props="footerProps"
          no-data-text="Nenhuma multa administrativa encontrada"
        >
          <template #item.acoes="{ item }">
            <v-btn
              v-if="canHandleDae(item)"
              :loading="loading"
              text
              variant="plain"
              @click="checkAbrirModal(item)"
            >
              <v-icon
                color="primary"
                text
                size="middle"
                title="Baixar PDF do DAE"
              >
                download
              </v-icon>
            </v-btn>
          </template>
          <template #item.dataVencimento="{ item }">
            <span>{{ formatDate(item.dataVencimento) }}</span>
          </template>
          <template #item.valorPrincipal="{ item }">
            <span class="money-cell">{{ formatCurrency(item.valorPrincipal) }}</span>
          </template>
          <template #item.nup="{ item }">
            <span>{{ formatNup(item.nup) }}</span>
          </template>
          <template #item.situacaoMulta="{ item }">
            <v-chip
              v-if="item.situacaoMulta"
              :color="getStatusColor(item.situacaoMulta)"
              dark
              small
              class="ma-0 pa-1"
            >
              {{ getSituacaoMultaLabel(item.situacaoMulta) }}
            </v-chip>
          </template>
          <template #item.daeSituacao="{ item }">
            <v-chip
              v-if="item.daeSituacao"
              :color="getStatusColor(item.daeSituacao)"
              dark
              small
              class="ma-0 pa-1"
            >
              {{ getDaeSituacaoLabel(item.daeSituacao) }}
            </v-chip>
          </template>
        </v-data-table>
        <DialogBaixarDae
          v-if="openDialogDae && selectedItem"
          :nosso-numero="selectedItem.dae"
          :cpf-cnpj="userGessan.cnpj"
          :data-vencimento="selectedItem.dataVencimentoDae"
          :is-grupo="userGessan?.isGrupo"
          @close="openDialogDae = false"
          @gerarDae="gerarNovoDAE"
        />

        <LoaderDialog
          :active-dialog="loader"
          message="Gerando DAE"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import AuthService from "@/services/gessan/auth.service";
import MultaAdministrativaService from "@/services/gessan/multaAdministrativa.service";
import SaneamentoService from "@/services/gessan/saneamento.service";
import MonthFilterPicker from "@/views/gessan/Saneamento/components/MonthFilterPicker.vue";
import FunctionsCommuns from "@/util/FunctionsCommuns";
import DialogBaixarDae from "@/views/gessan/Saneamento/components/DialogBaixarDae.vue";
import LoaderDialog from "@/components/LoaderDialog.vue";
import {
  DaeSituacao,
  SituacaoMulta,
} from "@/models/gessan/multaAdministrativa";
import moment from "moment";

const global = mapState("global", ["userGessan"]);

const createDefaultFilters = () => ({
  mesCompetencia: null,
  dataVencimentoDe: null,
  dataVencimentoAte: null,
  nup: null,
  autoInfracao: null,
});

const createDefaultPagination = () => ({
  page: 1,
  itemsPerPage: 10,
  sortBy: ["mesCompetencia"],
  sortDesc: [true],
});

const DAE_SITUACAO_LABELS = {
  [DaeSituacao.EMITIDO]: "Emitido",
  [DaeSituacao.PAGO]: "Pago",
  [DaeSituacao.CANCELADO]: "Cancelado",
};

const SITUACAO_MULTA_LABELS = {
  [SituacaoMulta.EMITIDA]: "Emitida",
  [SituacaoMulta.PAGA]: "Paga",
  [SituacaoMulta.CANCELADA]: "Cancelada",
};

export default {
  name: "MultasAdministrativas",
  components: {
    DialogBaixarDae,
    LoaderDialog,
    MonthFilterPicker,
  },
  data: () => ({
    filters: createDefaultFilters(),
    pagination: createDefaultPagination(),
    items: [],
    total: 0,
    isLoading: false,
    loading: false,
    loader: false,
    monthPickerKey: 0,
    isPaginationReady: false,
    selectedItem: null,
    openDialogDae: false,
  }),
  computed: {
    ...global,
    headers() {
      return [
        {
          text: "Mês competência",
          align: "start",
          sortable: true,
          value: "mesCompetencia",
        },
        {
          text: "Data vencimento",
          align: "start",
          sortable: true,
          value: "dataVencimento",
        },
        {
          text: "Valor principal",
          align: "start",
          sortable: true,
          value: "valorPrincipal",
        },
        {
          text: "NUP",
          align: "start",
          sortable: true,
          value: "nup",
        },
        {
          text: "Auto de infração",
          align: "start",
          sortable: true,
          value: "autoInfracao",
        },
        {
          text: "Situação da multa",
          align: "start",
          sortable: true,
          value: "situacaoMulta",
        },
        {
          text: "Situação do DAE",
          align: "start",
          sortable: true,
          value: "daeSituacao",
        },
        {
          text: "Ações",
          align: "start",
          sortable: false,
          value: "acoes",
        },
      ];
    },
    footerProps() {
      const itemsPerPageOptions = Array.from(
        new Set([5, 10, 50, this.total].filter(value => value && value > 0))
      ).sort((a, b) => a - b);

      return {
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageOptions,
      };
    },
    isGrupoMunicipio() {
      return !!this.userGessan?.isGrupo;
    },
  },
  watch: {
    pagination: {
      deep: true,
      handler() {
        if (!this.isPaginationReady) {
          return;
        }

        this.search();
      },
    },
  },
  mounted() {
    if (!this.isGrupoMunicipio) {
      AuthService.globalStore("error", "Listagem disponível apenas para Grupo Município");
      this.$router.replace({ name: "listagem-remuneracoes-regulatorias" });
      return;
    }

    this.search();
    this.$nextTick(() => {
      this.isPaginationReady = true;
    });
  },
  methods: {
    onChangeMesCompetencia(value) {
      this.filters.mesCompetencia = value;
    },
    onSubmit() {
      if (this.pagination.page !== 1) {
        this.pagination = {
          ...this.pagination,
          page: 1,
        };
        return;
      }

      this.search();
    },
    clearFilters() {
      this.filters = createDefaultFilters();
      this.monthPickerKey += 1;
      this.pagination = createDefaultPagination();
    },
    buildFilter() {
      const { page, itemsPerPage, sortBy, sortDesc } = this.pagination;
      const sortByKey = sortBy?.length ? sortBy[0] : "mesCompetencia";
      const sortOrder = sortDesc?.length ? (sortDesc[0] ? "DESC" : "ASC") : "DESC";

      return {
        ...this.filters,
        cnpj: this.userGessan?.cnpj,
        page: (page || 1) - 1,
        size: itemsPerPage || 10,
        sortBy: sortByKey,
        sortOrder,
      };
    },
    extractPage(response) {
      return response?.result || response?.data || response || {};
    },
    normalizeItems(content, page, size) {
      return (content || []).map((item, index) => ({
        ...item,
        mesCompetencia: item.mesCompetencia || item.competencia || null,
        dataVencimento: item.dataVencimento || null,
        valorPrincipal: item.valorPrincipal ?? item.valor ?? null,
        nup: item.nup || null,
        autoInfracao: item.autoInfracao || item.numeroAutoInfracao || null,
        situacaoMulta: this.normalizeSituacaoMulta(
          item.situacaoMulta || item.statusMulta || item.situacao
        ),
        daeSituacao: this.normalizeDaeSituacao(
          item.daeSituacao || item.statusDae || item.situacaoDae
        ),
        dae: item.dae || item.nossoNumero || null,
        dataVencimentoDae: item.dataVencimentoDae || item.dataVencimento || null,
        _rowKey:
          item.id ||
          `${item.nup || "sem-nup"}-${item.autoInfracao || "sem-auto"}-${
            item.dataVencimento || page * size + index
          }`,
      }));
    },
    search() {
      this.isLoading = true;
      const filter = this.buildFilter();

      MultaAdministrativaService.getList(filter).subscribe({
        next: response => {
          const page = this.extractPage(response);
          const content = page?.content || page?.data || [];

          this.items = this.normalizeItems(content, filter.page, filter.size);
          this.total = page?.totalElements || 0;
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
        },
      });
    },
    formatDate(value) {
      if (!value) {
        return "";
      }

      return FunctionsCommuns.formatBRDate(value);
    },
    formatCurrency(value) {
      if (value === null || value === undefined || value === "") {
        return "";
      }

      return `R$\u00A0${FunctionsCommuns.MonetaryFormat(value)}`;
    },
    formatNup(value) {
      if (!value) {
        return "";
      }

      const digits = value.toString().replace(/\D/g, "");

      if (digits.length !== 17) {
        return value;
      }

      return `${digits.slice(0, 5)}.${digits.slice(5, 11)}/${digits.slice(
        11,
        15
      )}-${digits.slice(15, 17)}`;
    },
    normalizeSituacaoMulta(value) {
      if (!value) {
        return null;
      }

      const normalized = value.toString().trim().toUpperCase();

      return Object.values(SituacaoMulta).includes(normalized)
        ? normalized
        : null;
    },
    normalizeDaeSituacao(value) {
      if (!value) {
        return null;
      }

      const normalized = value.toString().trim().toUpperCase();

      return Object.values(DaeSituacao).includes(normalized)
        ? normalized
        : null;
    },
    getSituacaoMultaLabel(value) {
      return SITUACAO_MULTA_LABELS[value] || value;
    },
    getDaeSituacaoLabel(value) {
      return DAE_SITUACAO_LABELS[value] || value;
    },
    getStatusColor(value) {
      const normalized = value?.toString().trim().toUpperCase();

      if ([SituacaoMulta.EMITIDA, DaeSituacao.EMITIDO].includes(normalized)) {
        return "blue darken-2";
      }

      if ([SituacaoMulta.PAGA, DaeSituacao.PAGO].includes(normalized)) {
        return "green darken-2";
      }

      if ([SituacaoMulta.CANCELADA, DaeSituacao.CANCELADO].includes(normalized)) {
        return "red darken-2";
      }

      return "blue-grey";
    },
    canHandleDae(item) {
      return (
        !!item?.dae &&
        item?.daeSituacao !== DaeSituacao.PAGO &&
        item?.situacaoMulta === SituacaoMulta.EMITIDA
      );
    },
    baixarDAE(item) {
      this.loading = true;
      this.loader = true;

      SaneamentoService.downloadDAE(item.dae).subscribe({
        next: response => {
          const filename = `DAE-${item.dae}.pdf`;
          const result = response.data;
          const blob = new Blob([result], {
            type: "application/octet-stream",
          });

          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();

          window.URL.revokeObjectURL(link.href);
          AuthService.globalStore("success", "Arquivo baixado de DAE com sucesso");
          this.search();
          this.loading = false;
          this.loader = false;
        },
        error: () => {
          this.loading = false;
          this.loader = false;
        },
      });
    },
    checkValidade(dataVencimento) {
      const date = moment(dataVencimento, ["DD/MM/YYYY", "YYYY-MM-DD"], true);

      if (!date.isValid()) {
        return false;
      }

      return date.isBefore(moment(), "day");
    },
    checkAbrirModal(item) {
      if (this.checkValidade(item.dataVencimentoDae)) {
        this.openDialogDae = true;
        this.selectedItem = item;
        return;
      }

      this.baixarDAE(item);
    },
    gerarNovoDAE(dae) {
      this.baixarDAE({ dae });
      this.search();
    },
  },
};
</script>

<style scoped>
.money-cell {
  white-space: nowrap;
}
</style>
